<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <div v-else>
            <div class="d-flex align-items-center justify-content-between mb-4">
                <div>
                    <h4 class="page-header-title">Input Gadai Kendaraan</h4>
                </div>
                <span class="page-header-subtitle">Langkah 1 — pilih anggota, form data kendaraan muncul setelahnya.</span>
            </div>

            <b-form @submit.prevent="calculateMaksimumPinjaman">
                <!-- 1. DATA ANGGOTA -->
                <div class="section-card">
                    <div class="section-card-header">
                        <span class="section-card-title">DATA ANGGOTA</span>
                        <div class="section-card-actions">
                            <b-button @click="openSearchAnggotaModal" name="modalSearchAnggotaBtn" class="btn-pill-primary">
                                Pilih Anggota
                            </b-button>
                            <b-button @click="addAnggota" name="modalAddAnggotaBtn" class="btn-pill-outline">
                                Anggota Baru
                            </b-button>
                        </div>
                    </div>
                    <div class="section-card-body">
                        <div class="member-info-panel mb-3">
                            <b-row>
                                <b-col md="6">
                                    <div class="member-item-row">
                                        <span class="member-item-label">No. Anggota</span>
                                        <span class="member-item-value font-weight-bold">{{ anggota.no }}</span>
                                    </div>
                                    <div class="member-item-row">
                                        <span class="member-item-label">No. Identitas</span>
                                        <span class="member-item-value">{{ anggota.noIdentitas }}</span>
                                    </div>
                                    <div class="member-item-row">
                                        <span class="member-item-label">No. HP</span>
                                        <span class="member-item-value">{{ anggota.noHp }}</span>
                                    </div>
                                    <div class="member-item-row">
                                        <span class="member-item-label">Alamat</span>
                                        <span class="member-item-value">{{ anggota.alamat }}</span>
                                    </div>
                                </b-col>
                                <b-col md="6">
                                    <div class="member-item-row">
                                        <span class="member-item-label">Jenis Identitas</span>
                                        <span class="member-item-value">{{ anggota.jenisIdentitas }}</span>
                                    </div>
                                    <div class="member-item-row">
                                        <span class="member-item-label">Nama</span>
                                        <span class="member-item-value">{{ anggota.nama }}</span>
                                    </div>
                                    <div class="member-item-row">
                                        <span class="member-item-label">No. Rumah</span>
                                        <span class="member-item-value">{{ anggota.noRumah }}</span>
                                    </div>
                                </b-col>
                            </b-row>
                        </div>
                        <b-alert :show="showAlertEditAnggota" variant="warning" class="mb-3">
                            <div>
                                * Data Anggota anda belum lengkap, Silakan lengkapi terlebih dahulu
                            </div>
                            <b-button variant="warning" size="sm" class="mt-2 text-white font-weight-bold" @click="$bvModal.show('modal-edit-anggota')">
                                <i class="fa fa-pencil mr-1"></i> Edit Anggota
                            </b-button>
                        </b-alert>
                        <div class="d-flex" v-if="anggota.no != '-'">
                            <b-button class="btn-outline-neutral mr-2" @click="$bvModal.show('modal-edit-anggota')">
                                Edit Anggota
                            </b-button>
                            <b-button class="btn-outline-neutral" @click="$bvModal.show('modal-detail-anggota')">
                                Detail Anggota
                            </b-button>
                        </div>
                    </div>
                </div>

                <!-- 2. DATA KENDARAAN -->
                <div class="section-card">
                    <div class="section-card-header">
                        <span class="section-card-title">DATA KENDARAAN </span>
                    </div>
                    <div class="section-card-body">
                        <!-- Baris 1: Tipe Pinjaman, Jenis Kendaraan, Merk Kendaraan -->
                        <b-row>
                            <b-col md="4">
                                <b-form-group label="Tipe Pinjaman">
                                    <b-form-select v-model="input.isBpkb" name="gadaiTipePinjaman" @change="checkNasabah">
                                        <b-form-select-option :value="false">Kendaraan + BPKB</b-form-select-option>
                                        <b-form-select-option :value="true">BPKB Saja</b-form-select-option>
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                            <b-col md="4">
                                <b-form-group label="Jenis Kendaraan">
                                    <b-form-select v-model="input.jenisKendaraan" name="gadaiJenisKendaraan">
                                        <template v-slot:first>
                                            <b-form-select-option :value="[ { id: null, name: null } ]" disabled>-- Please select an option --</b-form-select-option>
                                            <b-form-select-option v-for="(item, idx) in optKendaraanJenis" v-bind:value="{ id: item.id, name: item.name }" v-bind:key="idx">
                                                {{ item.name }}
                                            </b-form-select-option>
                                        </template>
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                            <b-col md="4">
                                <b-form-group label="Merk Kendaraan">
                                    <b-form-select v-model="input.merkKendaraan" name="gadaiMerkKendaraan" :disabled="optKendaraanMerk.length == 0">
                                        <template v-slot:first>
                                            <b-form-select-option :value="[ { id: null, name: null } ]" disabled>-- Please select an option --</b-form-select-option>
                                            <b-form-select-option v-for="(item, idx) in optKendaraanMerk" v-bind:value="{ id: item.id, name: item.name }" v-bind:key="idx">
                                                {{ item.name }}
                                            </b-form-select-option>
                                        </template>
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <!-- Baris 2: Tipe Kendaraan, Tahun, Kondisi / Grade Kendaraan -->
                        <b-row>
                            <b-col md="4">
                                <b-form-group label="Tipe Kendaraan">
                                    <multiselect
                                        name="gadaiTipeKendaraan"
                                        v-model="input.tipeKendaraan" 
                                        :disabled="optKendaraanTipe.length == 0"
                                        :options="optKendaraanTipe" 
                                        :internal-search="true"
                                        :allow-empty="true"
                                        deselect-label=""
                                        select-label=""
                                        label="name"
                                        track-by="name"
                                        placeholder="-- Please select an option --"
                                    />
                                </b-form-group>
                            </b-col>
                            <b-col md="4">
                                <b-form-group label="Tahun">
                                    <b-form-select v-model="input.tahunKendaraan" name="gadaiTahunKendaraan" :disabled="optKendaraanTahun.length == 0">
                                        <template v-slot:first>
                                            <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                                            <b-form-select-option v-for="(item, idx) in optKendaraanTahun" v-bind:value="{ id: item.id, name: item.name }" v-bind:key="idx">
                                                {{ item.name }}
                                            </b-form-select-option>
                                        </template>
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                            <b-col md="4">
                                <b-form-group label="Kondisi / Grade Kendaraan">
                                    <b-form-select v-model="input.kondisiKendaraan" name="gadaiKondisiKendaraan" :options="optKendaraanKondisi" :disabled="optKendaraanKondisi.length == 0">
                                        <template v-slot:first>
                                            <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                                        </template>
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <!-- Baris 3: Warna Kendaraan, Status Kendaraan, No. Polisi -->
                        <b-row>
                            <b-col md="4">
                                <b-form-group label="Warna Kendaraan">
                                    <b-form-select v-model="input.warnaKendaraan" name="gadaiWarnaKendaraan" :options="optKendaraanWarna" value-field="id" text-field="name">
                                        <template v-slot:first>
                                            <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                                        </template>
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                            <b-col md="4">
                                <b-form-group label="Status Kendaraan">
                                    <b-form-select v-model="input.statusKendaraan" name="gadaiStatusKendaraan" required>
                                        <template v-slot:first>
                                            <b-form-select-option value="" disabled>-- Please select an option --</b-form-select-option>
                                        </template>
                                        <b-form-select-option value="Atas Nama Sendiri">Atas Nama Sendiri</b-form-select-option>
                                        <b-form-select-option value="Atas Nama Orang Lain">Atas Nama Orang Lain</b-form-select-option>
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                            <b-col md="4">
                                <b-form-group label="No. Polisi">
                                    <b-form-input v-model="input.noPolisi" name="gadaiNoPolisi" required></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <!-- Kelengkapan Kendaraan -->
                        <b-form-group label="Kelengkapan Kendaraan" class="mt-2">
                            <div v-if="optKelengkapanKendaraan.length == 0" class="text-muted small">
                                Tidak ada kelengkapan dari jenis kendaraan yang dipilih.
                            </div>
                            <b-form-checkbox-group class="custom-checkbox-pill-group" v-else v-model="input.kelengkapanKendaraan" name="gadaiKelengkapanKendaraan">
                                <b-form-checkbox v-for="item in optKelengkapanKendaraan" v-bind:key="item.id" :value="{ id: item.id, name: item.name }">
                                    {{ item.name }}
                                </b-form-checkbox>
                            </b-form-checkbox-group>
                        </b-form-group>

                        <!-- Spesifikasi Kendaraan -->
                        <b-row class="mt-4">
                            <b-col md="6">
                                <label class="font-weight-bold text-dark d-block mb-2" style="font-size: 13px;">Spesifikasi Kendaraan (Jenis)</label>
                                <div class="mb-2">
                                    <span class="text-muted small font-weight-bold d-block mb-1">Penambahan</span>
                                    <div v-if="optKendaraanSpekJenis.penambahan.length == 0" class="text-muted small mb-2">
                                        Tidak ada penambahan spesifikasi dari jenis kendaraan yang dipilih.
                                    </div>
                                    <b-form-checkbox-group class="checkbox-group" v-else v-model="input.spesifikasiKendaraanJenis" name="gadaiPenambahanSpekJenisBarangKend">
                                        <b-form-checkbox class="d-block mb-1" v-for="item in optKendaraanSpekJenis.penambahan" v-bind:key="item.id" :value="item.id">
                                            {{ item.name }}
                                        </b-form-checkbox>
                                    </b-form-checkbox-group>
                                </div>
                                <div>
                                    <span class="text-muted small font-weight-bold d-block mb-1">Pengurangan</span>
                                    <div v-if="optKendaraanSpekJenis.pengurangan.length == 0" class="text-muted small mb-2">
                                        Tidak ada pengurangan spesifikasi dari jenis kendaraan yang dipilih.
                                    </div>
                                    <b-form-checkbox-group class="checkbox-group" v-else v-model="input.spesifikasiKendaraanJenis" name="gadaiPenguranganSpekJenisBarangKend">
                                        <b-form-checkbox class="d-block mb-1" v-for="item in optKendaraanSpekJenis.pengurangan" v-bind:key="item.id" :value="item.id">
                                            {{ item.name }}
                                        </b-form-checkbox>
                                    </b-form-checkbox-group>
                                </div>
                            </b-col>
                            <b-col md="6">
                                <label class="font-weight-bold text-dark d-block mb-2" style="font-size: 13px;">Spesifikasi Kendaraan (Merk)</label>
                                <div class="mb-2">
                                    <span class="text-muted small font-weight-bold d-block mb-1">Penambahan</span>
                                    <div v-if="optKendaraanSpekMerk.penambahan.length == 0" class="text-muted small mb-2">
                                        Tidak ada penambahan spesifikasi dari merk kendaraan yang dipilih.
                                    </div>
                                    <b-form-checkbox-group class="checkbox-group" v-else v-model="input.spesifikasiKendaraanMerk" name="gadaiPenambahanSpekMerkBarangKend">
                                        <b-form-checkbox class="d-block mb-1" v-for="item in optKendaraanSpekMerk.penambahan" v-bind:key="item.id" :value="item.id">
                                            {{ item.name }}
                                        </b-form-checkbox>
                                    </b-form-checkbox-group>
                                </div>
                                <div>
                                    <span class="text-muted small font-weight-bold d-block mb-1">Pengurangan</span>
                                    <div v-if="optKendaraanSpekMerk.pengurangan.length == 0" class="text-muted small mb-2">
                                        Tidak ada pengurangan spesifikasi dari merk kendaraan yang dipilih.
                                    </div>
                                    <b-form-checkbox-group class="checkbox-group" v-else v-model="input.spesifikasiKendaraanMerk" name="gadaiPenguranganSpekMerkBarangKend">
                                        <b-form-checkbox class="d-block mb-1" v-for="item in optKendaraanSpekMerk.pengurangan" v-bind:key="item.id" :value="item.id">
                                            {{ item.name }}
                                        </b-form-checkbox>
                                    </b-form-checkbox-group>
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                </div>

                <!-- 3. DATA STNK -->
                <div class="section-card">
                    <div class="section-card-header">
                        <span class="section-card-title">DATA STNK</span>
                    </div>
                    <div class="section-card-body">
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="STNK Atas Nama">
                                    <b-form-input v-model="input.namaStnk" name="gadaiNamaStnk" required></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Masa berlaku pajak STNK">
                                    <b-form-input v-model="input.masaBerlakuStnk" name="gadaiMasaBerlakuStnk" type="date" required></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-form-group label="Alamat STNK">
                            <b-form-input v-model="input.alamatStnk" name="gadaiAlamatStnk" required></b-form-input>
                        </b-form-group>
                    </div>
                </div>

                <!-- 4. DATA BPKB -->
                <div class="section-card">
                    <div class="section-card-header">
                        <span class="section-card-title">DATA BPKB</span>
                    </div>
                    <div class="section-card-body">
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="No. BPKB">
                                    <b-form-input v-model="input.noBpkb" name="gadaiNoBpkb" required></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="BPKB Atas Nama">
                                    <b-form-input v-model="input.namaBpkb" name="gadaiNamaBpkb" required></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="No. Mesin">
                                    <b-form-input v-model="input.noMesin" name="gadaiNoMesin" required></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="No. Rangka">
                                    <b-form-input v-model="input.noRangka" name="gadaiNoRangka" required></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </div>
                </div>

                <!-- 5. DATA PENDUKUNG -->
                <div class="section-card">
                    <div class="section-card-header">
                        <span class="section-card-title">DATA PENDUKUNG</span>
                    </div>
                    <div class="section-card-body">
                        <b-button class="btn-pill-primary mb-3" @click="addFotoPendukung" name="fotoPendukungAddBtn">
                            <i class="fa fa-plus mr-1"></i> Foto Pendukung
                        </b-button>
                        <div class="text-danger small mb-3" v-show="fotoPendukungError">* Foto Pendukung Maksimal 6 Foto</div>
                    
                        <FotoPendukung 
                            v-for="item in input.fotoPendukung" 
                            v-bind:key="item.index" 
                            :fotoPendukung="item" 
                            :length="input.fotoPendukung.length" 
                            :minLength="minLengthFotoPendukung"
                            @remove="removeFotoPendukung"
                            @showModalCam="openModalCam" 
                            @showModalPreview="openModalPreview"
                        />
                        <div class="small text-muted mt-2">
                            * Foto Pendukung maksimal 6 foto.
                        </div>
                    </div>
                </div>

                <!-- 6. PROMO -->
                <div class="section-card">
                    <div class="section-card-header section-card-header--promo">
                        <span class="section-card-title">PROMO</span>
                    </div>
                    <div class="section-card-body">
                        <b-button class="btn-outline-neutral" @click="checkPromo" :disabled="isGettingPromo">
                            {{ isGettingPromo ? "Mengambil..." : "Cek Promo yang Dapat Digunakan" }}
                            <i class="fa fa-search ml-2"></i>
                        </b-button>
                        <div class="detail-promo-data mt-3" v-if="!isGettingPromo && isPromoRetrieved">
                            <div v-if="optPromo.length == 0" class="text-danger small">
                                * Tidak ada promo yang bisa digunakan untuk pemilihan barang gadai ini.
                            </div>
                            <b-form-checkbox-group v-else v-model="input.promo" name="promoList" stacked>
                                <b-form-checkbox class="mb-1 font-weight-500" v-for="item in optPromo" v-bind:key="item.id" :value="item.id">{{ item.name }}</b-form-checkbox>
                            </b-form-checkbox-group>
                        </div>
                    </div>
                </div>

                <!-- 7. HARGA KENDARAAN LAINNYA -->
                <div class="section-card" v-if="showDataLainnya && input.merkKendaraan.name == 'Lainnya' && input.tipeKendaraan.name == 'Lainnya'">
                    <div class="section-card-header">
                        <span class="section-card-title">HARGA KENDARAAN LAINNYA</span>
                    </div>
                    <div class="section-card-body">
                        <b-form-group label="Nominal Harga">
                            <b-input-group prepend="Rp.">
                                <b-form-input v-model="input.nominalHargaLainnya" name="nominalHargaLainnya"></b-form-input>
                            </b-input-group>
                        </b-form-group>
                        <b-form-group label="Nominal Admin Fee" class="mt-3">
                            <b-input-group prepend="Rp.">
                                <b-form-input v-model="input.nominalAdminFeeLainnya" name="nominalAdminFeeLainnya" required></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </div>
                </div>

                <!-- SUBMIT ACTION -->
                <div class="d-flex justify-content-end mb-4">
                    <b-button type="submit" name="gadaiSubmitBtn" class="btn-pill-primary" style="padding: 10px 32px !important; font-size: 15px !important;" :disabled="isSubmitting">
                        {{ isSubmitting ? "Menghitung..." : "Hitung" }}
                    </b-button>
                </div>
            </b-form>
            <b-modal id="modal-input-anggota" body-class="modal-nopadding" size="xl" title="Input Anggota" hide-footer no-close-on-esc no-close-on-backdrop>
                <InputAnggota :isModal="modalAnggota" @submitModalAnggota="inputNewAnggota" />
            </b-modal>
            <b-modal id="modal-edit-anggota" body-class="modal-nopadding" size="xl" title="Edit Anggota" hide-footer no-close-on-esc no-close-on-backdrop>
                <EditAnggota :isModal="modalAnggota" :idAnggota="anggota.id" :requiredForDataKerabatAndPihakLain="input.isBpkb" @updateModalAnggota="editNewAnggota" />
            </b-modal>
            <b-modal id="modal-detail-anggota" body-class="modal-nopadding" size="xl" title="Detail Anggota" no-close-on-backdrop>
                <DetailAnggota :isModal="modalAnggota" :idAnggota="anggota.id" />
                <template v-slot:modal-footer="{ cancel }">
                    <b-button variant="secondary" name="cancelDetailAnggotaBtn" @click="cancel()">
                        Tutup
                    </b-button>
                </template>
            </b-modal>
            <ModalPilihAnggota @anggota-selected="selectAnggota" />
            <ModalRincian :namaLengkapBarang="namaLengkapBarang" :rincian="rincian" :isSubmitting="isSubmitting" @next="calculateConfirmation" />
            <ModalKonfirmasi 
                :isSubmitting="isSubmitting" :nilaiPinjaman="input.nilaiPinjaman"
                :anggota="anggota" :rincian="rincian" :namaLengkapBarang="namaLengkapBarang"
                @exec-submit="submitGadai"
            />
            <ModalSukses :rincian="rincian" @done="reset" />
            <ModalWebCam idWebcam="webcam-input-kend" @photoTaken="setResult"  />
            <ModalPreview modalId="modal-preview-gadai" :fotoPreview="activeFotoPreview" />
            <b-modal id="modal-confirm-lanjutGadai" title="Confirm Info Gadai" hide-header-close no-close-on-esc no-close-on-backdrop>
                <p class="mb-0">Mohon informasikan IG terlebih dahulu mengenai data mobil yang akan digadaikan. Hanya lanjutkan apabila pihak IG sudah memberikan perintah untuk melanjutkan input gadai.</p>
                <template v-slot:modal-footer="{ cancel }">
                    <b-button variant="secondary" name="closeDetailBtn" @click="cancel()">
                        Lanjutkan Gadai
                    </b-button>
                </template>
            </b-modal>
            <b-modal id="modal-info-update" title="Update Data Anggota" hide-footer no-close-on-esc no-close-on-backdrop>
                <p>Mohon klik tombol Edit Anggota dan pastikan data anggota sudah sesuai dengan kartu identitas anggota!</p>
                <p>
                    <strong>
                        Pastikan alamat (kota, kecamatan, kelurahan) dan foto identitas sudah benar.
                    </strong>
                </p>
                <p>
                    Catatan: Bila data sudah benar semua dari awal, mohon untuk tetap menekan tombol Update ketika Edit Anggota.
                </p>
                <b-button variant="pgiBtn" class="mr-2" @click="showModalEditAnggota()">
                    <i class="fa fa-pencil mr-2"></i>
                    Edit Anggota
                </b-button>
            </b-modal>
        </div>
    </div>
</template>

<script>
import ModalPilihAnggota from '../ModalPilihAnggota'
import ModalRincian from '../ModalRincian'
import ModalKonfirmasi from '../ModalKonfirmasi'
import ModalSukses from '../ModalSukses'
import InputAnggota from '../../master/anggota/InputAnggota'
import EditAnggota from '../../master/anggota/EditAnggota'
import DetailAnggota from '../../master/anggota/DetailAnggota'
import FotoPendukung from '../../../components/webcam/FotoPendukung'
import ModalWebCam from '../../../components/webcam/ModalWebCam'
import ModalPreview from '../../../components/webcam/ModalPreview'

export default {
    name: 'input-gadai-kendaraan',
    components: {
        ModalPilihAnggota,
        ModalRincian,
        ModalKonfirmasi,
        ModalSukses,
        InputAnggota,
        EditAnggota,
        DetailAnggota,
        FotoPendukung,
        ModalWebCam,
        ModalPreview
    },
    data() {
        return {

            initStatus: 0,
            isGettingPromo: false,
            isPromoRetrieved: false,
            isSubmitting: false,

            modalAnggota: true,
            showAlertEditAnggota: false,

            anggota: {
                id: null,
                nama: "-",
                no: "-",
                jenisIdentitas: "-",
                noIdentitas: "-",
                noHp: "-",
                noRumah: "-",
                alamat: "-",
                isComplete: false,
                shouldUpdate: false,
            },

            rincian: {
                hargaBarang: 0,
                maksimumPinjaman: 0,
                minimumPinjaman: 0,
                perhitunganPromo: null,
                perhitunganKondisi: {},
                perhitunganSpek: [],
                perhitunganBonusGadaiPertama: {},
                perhitunganStatusAnggota: {},
                biayaAdmin: 0,
                noFaktur: "",
                showAlertNoFakturGanda: "false",
                alertNoPol: "",
                alertNoFakturGanda: "",
                alertNoMesin: "",
                alertGadai: "kend"
            },

            namaLengkapBarang: "",

            input: {

                isBpkb: false,
                jenisKendaraan: [ { id: null, name: null } ],
                merkKendaraan: [ { id: null, name: null } ],
                tipeKendaraan: null,
                tahunKendaraan: null,
                kondisiKendaraan: null,
                warnaKendaraan: null,
                statusKendaraan: "Atas Nama Sendiri",
                kelengkapanKendaraan: [],
                spesifikasiKendaraanJenis: [],
                spesifikasiKendaraanMerk: [],
                noPolisi: "",
                namaStnk: "",
                alamatStnk: "",
                masaBerlakuStnk: "",
                noBpkb: "",
                namaBpkb: "",
                noMesin: "",
                noRangka: "",
                promo: [],
                nilaiPinjaman: 0,

                fotoPendukung: [
                    {
                        index: 0, 
                        id: 0, 
                        checkFotoBarangPendukung: false,
                        fotoBarangPendukungPlaceholder: 'Choose a file',
                        fotoBarangPendukung: null,
                        fotoBarangPendukungBase64: null,
                        activeFotoPendukungBase64: null
                    }
                ],

                nominalHargaLainnya: null,
                nominalAdminFeeLainnya: null

            },

            indexFotoPendukung: 1,
            fotoPendukungError: false,
            activeFotoPendukungIndex: null,
            activeFotoPreviewIndex: null,
            minLengthFotoPendukung: 1,
            activeFotoPreview: "",

            optKendaraanJenis: [],
            optKendaraanMerk: [],
            optKendaraanTipe: [],
            optKendaraanTahun: [],
            optKendaraanKondisi: [],
            optKendaraanSpekJenis: {
				penambahan : [],
				pengurangan : []
			},
            optKendaraanSpekMerk: {
				penambahan : [],
				pengurangan : []
			},
            optKelengkapanKendaraan: [],
            optKendaraanWarna: [],

            optPromo: [],
            jenisIdentitas: [],
            requiredForDataKerabatAndPihakLain: false,
            cabangId: '',
            
            showDataLainnya : 'false'
        }

    }, 
    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init() {

            this.initStatus = 0

            let getJenisKendaraan = this.$axios.get("barang-jenis/kendaraan").then(response => {
                this.optKendaraanJenis = response.data
            })

            let getWarnaKend = this.$axios.get("gadai/warna").then(response => {
                this.optKendaraanWarna = response.data
            })

            Promise.all([getJenisKendaraan, getWarnaKend]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
            
            this.cabangId = this.$helper.getCabangId()
        },

        reset() {

            this.$bvModal.hide("modal-sukses")
            this.$bvModal.hide("modal-konfirmasi")
            this.$bvModal.hide("modal-rincian")

            this.anggota.id = null
            this.anggota.nama = "-"
            this.anggota.no = "-"
            this.anggota.jenisIdentitas = "-"
            this.anggota.noIdentitas = "-"
            this.anggota.noHp = "-"
            this.anggota.noRumah = "-"
            this.anggota.alamat = "-"

            this.input.isBpkb = false
            this.input.jenisKendaraan = [ { id: null, name: null } ]
            this.input.merkKendaraan = [ { id: null, name: null } ]
            this.input.tipeKendaraan = null
            this.input.tahunKendaraan = null
            this.input.kondisiKendaraan = null
            this.input.warnaKendaraan = null
            this.input.kelengkapanKendaraan = []
            this.input.spesifikasiKendaraanJenis = []
            this.input.spesifikasiKendaraanMerk = []
            this.input.statusKendaraan = "Atas Nama Sendiri"
            this.input.noPolisi = ""
            this.input.namaStnk = ""
            this.input.alamatStnk = ""
            this.input.masaBerlakuStnk = ""
            this.input.noBpkb = ""
            this.input.namaBpkb = ""
            this.input.noMesin = ""
            this.input.noRangka = ""
            this.input.fotoPendukung = [
                {
                    id: 0, 
                    index: this.indexFotoPendukung, 
                    checkFotoBarangPendukung: false,
                    fotoBarangPendukungPlaceholder: 'Choose a file',
                    fotoBarangPendukung: null,
                    fotoBarangPendukungBase64: null,
                    activeFotoPendukungBase64: null
                }
            ]
            
            window.scroll(0, 0)

        },

        addAnggota() {
            this.$bvModal.show("modal-input-anggota");
        },

        openSearchAnggotaModal() {
            this.$bvModal.show("modal-pilih-anggota")
        },

        selectAnggota(item) {

            this.anggota.id = item.id
            this.anggota.nama = item.nama
            this.anggota.no = item.no
            this.anggota.jenisIdentitas = item.jenisIdentitas.name
            this.anggota.noIdentitas = item.noIdentitas
            this.anggota.noHp = item.noHp
            this.anggota.noRumah = item.noRumah
            this.anggota.alamat = item.alamat
            this.anggota.isComplete = item.isComplete
            this.anggota.shouldUpdate = item.shouldUpdateData
            if(this.anggota.shouldUpdate == true){
                this.$bvModal.hide("modal-pilih-anggota")
                this.$bvModal.show("modal-info-update")
            }else{
                this.$bvModal.hide("modal-pilih-anggota")
            }
        },

        showModalEditAnggota(){
            this.$bvModal.show("modal-edit-anggota")
            this.$bvModal.hide("modal-info-update")
        },

        checkPromo() {
            
            if(this.input.jenisKendaraan !== null && this.input.merkKendaraan !== null && this.input.tipeKendaraan !== null && this.input.tahunKendaraan != null) {

                let path = 'gadai-crud/promo?jenisPinjamanId=2&jenisBarangId=' 
                    + this.input.jenisKendaraan.id
                    + '&merkId=' + this.input.merkKendaraan.id
                    + '&tipeId=' + this.input.tipeKendaraan.id
                    + "&tahunId=" + this.input.tahunKendaraan.id
                    + "&isBpkb=" + this.input.isBpkb
                    + '&cabangId=' + this.cabangId

                this.input.promo = []

                this.isGettingPromo = true
                this.$axios.get(path).then(response => {
                    this.optPromo = response.data
                    this.isPromoRetrieved = true
                })
                .catch(error => {
                    this.$helper.parseError(this, error)
                })
                .finally(() => {
                    this.isGettingPromo = false
                })

            }
            else {
                this.$helper.toastErr(this, "Mohon lengkapi jenis, merk, tipe, dan tahun barang terlebih dahulu")
            }

        },

        calculateMaksimumPinjaman() {

            // Check all data has been filled
            if(this.anggota.id == null) {
                this.$helper.toastErr(this, "Mohon memilih anggota terlebih dahulu!")
                return
            }

            if(this.input.jenisKendaraan == null || this.input.merkKendaraan == null || this.input.warnaKendaraan == null
                || this.input.tipeKendaraan == null || this.input.tahunKendaraan == null || this.input.kondisiKendaraan == null
            ) {
                this.$helper.toastErr(this, "Mohon lengkapi data gadai terlebih dahulu!")
                return
            }

            // Check if there is at least one picture attached
            if(this.input.fotoPendukung.length == 1 && this.$helper.isNullOrEmpty(this.input.fotoPendukung[0].activeFotoPendukungBase64)) {
                this.$helper.toastErr(this, "Mohon upload minimal 1 gambar!")
                return
            }

            // Check if all photo row has been filled
            for(var i = 0; i < this.input.fotoPendukung.length; i++) {
                let item = this.input.fotoPendukung[i]
                if(this.$helper.isNullOrEmpty(item.activeFotoPendukungBase64)) {
                    this.$helper.toastErr(this, "Terdapat upload gambar yang kosong, periksa kembali!")
                    return
                }
            }

            let payload = this.preparePayload()
            
            this.isSubmitting = true
            this.$axios.post("gadai-crud/gadai/kendaraan", payload).then(response => { 

                if(response.data.noFaktur == 'REFRESH_KONDISI'){
                    this.$helper.toastErr(this, "Harga barang baru saja diperbarui HO. Silahkan isi ulang Kondisi / Grade Barang!")
                    this.input.kondisiKendaraan = null
                    this.optKendaraanKondisi = []
                    this.$axios.get(`barang-tipe/kondisi/${this.input.tipeKendaraan.id}`).then(response => {
                        let responseKondisi = response.data
                        for (let y=0; y< responseKondisi.length; y++){
                            let dataKondisi = {}
                            dataKondisi.value = responseKondisi[y].id
                            dataKondisi.text = responseKondisi[y].name.substring(4)
                            this.optKendaraanKondisi.push(dataKondisi)
                        }
                    })
                    .catch(error => {
                        this.$helper.parseError(this, error)
                    })
                }else{
                    let data = response.data
                    this.rincian = data
                    console.log(response.data)

                    if(response.data.noFakturSuspectGanda != null){
                        this.rincian.showAlertNoFakturGanda = true
                        this.rincian.alertNoPol = this.input.noPolisi
                        this.rincian.alertNoMesin = this.input.noMesin
                        this.rincian.alertGadai = "kend"
                        this.rincian.alertNoFakturGanda = response.data.noFakturSuspectGanda
                    }

                    // Arrange nama lengkap barang
                    this.namaLengkapBarang = `${this.input.jenisKendaraan.name} - ${this.input.merkKendaraan.name} - ${this.input.tipeKendaraan.name}`
                    if(this.input.tahunKendaraan != null) {
                        this.namaLengkapBarang += ` - ${this.input.tahunKendaraan.name}`
                    }

                    this.$bvModal.show("modal-rincian")
                }

            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
            
        },

        calculateConfirmation(nilaiPinjaman) {
            if (nilaiPinjaman % 50000 != 0) this.$helper.toastErr(this, "Pinjaman hanya boleh dalam kelipatan Rp 50.000")
            else {
                let payload = this.preparePayload(nilaiPinjaman)

                this.isSubmitting = true
                this.$axios.post("gadai-crud/gadai/kendaraan", payload).then(response => {

                    if(response.data.noFaktur == 'REFRESH_KONDISI'){
                        this.$helper.toastErr(this, "Harga barang baru saja diperbarui HO. Silahkan isi ulang Kondisi / Grade Barang!")
                        this.input.kondisiKendaraan = null
                        this.optKendaraanKondisi = []
                        this.$axios.get(`barang-tipe/kondisi/${this.input.tipeKendaraan.id}`).then(response => {

                            let responseKondisi = response.data
                            for (let y=0; y< responseKondisi.length; y++){
                                let dataKondisi = {}
                                dataKondisi.value = responseKondisi[y].id
                                dataKondisi.text = responseKondisi[y].name.substring(4)
                                this.optKendaraanKondisi.push(dataKondisi)
                            }

                        })
                        .catch(error => {
                            this.$helper.parseError(this, error)
                        })
                        this.$bvModal.hide("modal-rincian")
                    }else{
                        let data = response.data
                        this.rincian = data

                        this.$bvModal.show("modal-konfirmasi")
                    }

                })
                .catch(error => {
                    this.$helper.parseError(this, error)
                })
                .finally(() => {
                    this.isSubmitting = false
                })
            }
        },

        submitGadai() {

            let payload = this.preparePayload(this.input.nilaiPinjaman, true)

            this.isSubmitting = true
            this.$axios.post("gadai-crud/gadai/kendaraan", payload, { timeout: 300000 }).then(response => {
                
                if(response.data.noFaktur == 'REFRESH_KONDISI'){
                    this.$helper.toastErr(this, "Harga barang baru saja diperbarui HO. Silahkan isi ulang Kondisi / Grade Barang!")
                    this.input.kondisiKendaraan = null
                    this.optKendaraanKondisi = []
                    this.$axios.get(`barang-tipe/kondisi/${this.input.tipeKendaraan.id}`).then(response => {

                        let responseKondisi = response.data
                        for (let y=0; y< responseKondisi.length; y++){
                            let dataKondisi = {}
                            dataKondisi.value = responseKondisi[y].id
                            dataKondisi.text = responseKondisi[y].name.substring(4)
                            this.optKendaraanKondisi.push(dataKondisi)
                        }

                    })
                    .catch(error => {
                        this.$helper.parseError(this, error)
                    })
                    this.$bvModal.hide("modal-konfirmasi")
                    this.$bvModal.hide("modal-rincian")
                }else{
                    this.input.jenisKendaraan = [ { id: null, name: null } ]
                    this.input.merkKendaraan = [ { id: null, name: null } ]
                    this.input.tipeKendaraan = null

                    let data = response.data
                    this.rincian.noFaktur = data.noFaktur

                    this.$bvModal.show("modal-sukses")
                }

            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })

        },

        preparePayload(nilaiPinjaman = null, finalizePayment = false) {

            let payload = new FormData()
            payload.append("nasabahId", this.anggota.id)
            payload.append("jenisPinjamanId", 2) // MARK HARDCODE
            payload.append("jenisBarangId", this.input.jenisKendaraan.id)
            payload.append("merkId", this.input.merkKendaraan.id)
            payload.append("tipeId", this.input.tipeKendaraan.id)
            payload.append("kondisiId", this.input.kondisiKendaraan)
            payload.append("cabangId", localStorage.getItem("activeCabangId"))
            payload.append("finalizePayment", finalizePayment)
            payload.append("warnaId", this.input.warnaKendaraan)
            payload.append("isBpkb", this.input.isBpkb)
            payload.append("statusKendaraan", this.input.statusKendaraan)
            payload.append("stnkAtasNama", this.input.namaStnk)
            payload.append("stnkAlamat", this.input.alamatStnk)
            payload.append("stnkMasaBerlakuPajak", this.input.masaBerlakuStnk)
            payload.append("noBpkb", this.input.noBpkb)
            payload.append("bpkbAtasNama", this.input.namaBpkb)
            payload.append("noMesin", this.input.noMesin)
            payload.append("noRangka", this.input.noRangka)
            payload.append("noPolisi", this.input.noPolisi)

            if (this.input.nominalHargaLainnya != null) payload.append("hargaBarangLainnya", this.input.nominalHargaLainnya)
            if (this.input.nominalAdminFeeLainnya != null) payload.append("adminFeeLainnya", this.input.nominalAdminFeeLainnya)

            // Append all checked spesifikasi
            for(let spek of this.input.spesifikasiKendaraanJenis) {
                payload.append("spesifikasiId", spek)
            }

            for(let spek of this.input.spesifikasiKendaraanMerk) {
                payload.append("spesifikasiId", spek)
            }

            // Append promo, if any is selected
            this.input.promo.forEach(promoId => {
                payload.append("promoIds", promoId)
            })

            // Kelengkapan
            if(this.input.kelengkapanKendaraan.length != 0) {

                this.input.kelengkapanKendaraan.forEach(item => {
                    payload.append("kelengkapan", item.name)
                })

            }
            
            // Append tahun, if selected
            if(this.$helper.isNotNullAndNotEmpty(this.input.tahunKendaraan)) {
                payload.append("tahunId", this.input.tahunKendaraan.id)
            }

            // Append peminjaman, if nilai pinjaman is not null
            if(nilaiPinjaman != null) {
                this.input.nilaiPinjaman = nilaiPinjaman
                payload.append("jumlahPinjaman", nilaiPinjaman)
            }

            // Upload photo only if on final step
            if(finalizePayment) {

                let jsonFoto = []
                this.input.fotoPendukung.forEach(function(entry) {
                    jsonFoto.push(entry.activeFotoPendukungBase64)  
                })
                payload.append("foto", JSON.stringify(jsonFoto))

            }

            this.$helper.printPayload(payload)

            return payload

        },

        inputNewAnggota(dataAnggota){
            //hide modal confirm dan modal anggota
            
            this.$bvModal.hide("modal-confirm-input");
            this.$bvModal.hide("modal-input-anggota");
            
            this.anggota.id = dataAnggota.idAnggota
            this.anggota.nama = dataAnggota.nama
            this.anggota.no = dataAnggota.noAnggota
            this.anggota.jenisIdentitas = dataAnggota.jenisIdentitas.name
            this.anggota.noIdentitas = dataAnggota.noIdentitas
            this.anggota.noHp = dataAnggota.noHp
            this.anggota.noRumah = dataAnggota.noRumah
            this.anggota.alamat = dataAnggota.alamat
            this.anggota.isComplete = dataAnggota.isComplete
        },

        editNewAnggota(dataAnggota){
            //hide modal confirm dan modal anggota
            
            this.$bvModal.hide("modal-confirm-edit");
            this.$bvModal.hide("modal-edit-anggota");
            
            this.anggota.id = dataAnggota.idAnggota
            this.anggota.nama = dataAnggota.nama
            this.anggota.no = dataAnggota.noAnggota
            this.anggota.noIdentitas = dataAnggota.noIdentitas
            this.anggota.noHp = dataAnggota.noHp
            this.anggota.noRumah = dataAnggota.noRumah
            this.anggota.alamat = dataAnggota.alamat
            this.anggota.isComplete = dataAnggota.isComplete
            this.checkNasabah()
        },

        checkTipePinjaman(){
            this.checkNasabah()
        },
        
        checkNasabah(){
            if(this.input.isBpkb && this.anggota.id!==null){
                if(!this.anggota.isComplete){
                    this.showAlertEditAnggota = true
                }else{
                    this.showAlertEditAnggota = false
                }
            }else{
                this.showAlertEditAnggota = false
            }
        },

        openModalCam(index){
            this.activeFotoPendukungIndex = index
            this.$bvModal.show("webcam-input-kend")
        },

        openModalPreview(index){
            this.activeFotoPreviewIndex = index
            let idx = this.input.fotoPendukung.findIndex(item => item.index == this.activeFotoPreviewIndex);
            this.activeFotoPreview = this.input.fotoPendukung[idx].fotoBarangPendukungBase64
            this.$bvModal.show("modal-preview-gadai")
        },

        async setResult(result){
            //letakin ke null masing2
            var newResult = await this.$helper.resizeImage(result)
            let idx = this.input.fotoPendukung.findIndex(item => item.index == this.activeFotoPendukungIndex);
            this.input.fotoPendukung[idx].fotoBarangPendukungBase64 = newResult
            this.input.fotoPendukung[idx].activeFotoPendukungBase64 = newResult
            this.input.fotoPendukung[idx].fotoBarangPendukungPlaceholder = "Foto dari Kamera"
            this.input.fotoPendukung[idx].checkFotoBarangPendukung = true
        },

        //----------------- Fungsi Tambah Hapus Data Foto Pendukung -----------------

        addFotoPendukung() {
            if(this.indexFotoPendukung < 6){
                this.input.fotoPendukung.unshift({ 
                    index: this.indexFotoPendukung, 
                    id: 0, 
                    index: this.indexFotoPendukung,
                    checkFotoBarangPendukung: false,
                    fotoBarangPendukungPlaceholder: 'Choose a file',
                    fotoBarangPendukung: null,
                    fotoBarangPendukungBase64: null,
                    activeFotoPendukungBase64: null
                })
                this.indexFotoPendukung++;
            }else{
                this.fotoPendukungError = true;
            }
        },

        removeFotoPendukung(index) {
            this.input.fotoPendukung = this.input.fotoPendukung.filter(item => item.index != index)
            this.fotoPendukungError = false;
        },

    },
    watch: {

        'input.isBpkb': function() {
            this.checkNasabah()
        },

        'anggota.alamat': function(newVal) {
            this.checkNasabah()
        },
        'input.jenisKendaraan': function(newVal) {
            
            this.optKendaraanMerk = []
            this.input.merkKendaraan = [ { id: null, name: null } ]

            this.optKelengkapanKendaraan = []
            this.input.kelengkapanKendaraan = []

            this.optKendaraanSpekJenis = {
				penambahan : [],
				pengurangan : []
			}
            this.input.spesifikasiKendaraanJenis = []

            this.optPromo = []
            this.input.promo = []
            this.isPromoRetrieved = false

            if(newVal.id == undefined) { return }

            if(newVal.name == 'Mobil'){
                this.$bvModal.show("modal-confirm-lanjutGadai")
            }

            if(newVal.id != undefined){
                if(this.input.jenisKendaraan.name.startsWith('Lainnya')){
                    this.showDataLainnya = true
                }
                // Lookup Merk
                this.$axios.get(`barang-merk/jenis/${newVal.id}`).then(response => {
                    this.optKendaraanMerk = response.data
                })
                .catch(error => {
                    this.$helper.parseError(this, error)
                })

                // Lookup Kelengkapan Kendaraan
                this.$axios.get(`barang-jenis/kelengkapan?jenisId=${newVal.id}`).then(response => {
                    this.optKelengkapanKendaraan = response.data
                })
                .catch(error => {
                    this.$helper.parseError(this, error)
                })

                // Lookup Spek Jenis
                this.$axios.get(`barang-jenis/spesifikasi?jenisId=${newVal.id}`).then(response => {
                    this.optKendaraanSpekJenis = response.data
                })
                .catch(error => {
                    this.$helper.parseError(this, error)
                })
            }

        },

        'input.merkKendaraan': function(newVal) {

            this.optKendaraanTipe = []
            this.input.tipeKendaraan = null
            
            this.optKendaraanSpekMerk = {
				penambahan : [],
				pengurangan : []
			}
            this.input.spesifikasiKendaraanMerk = []

            this.optPromo = []
            this.input.promo = []
            this.isPromoRetrieved = false

            if(newVal.id == undefined) { return }

            if(newVal.id != undefined){
                // Lookup Tipe
                this.$axios.get(`barang-tipe/merk/${newVal.id}`).then(response => {
                    this.optKendaraanTipe = response.data
                })
                .catch(error => {
                    this.$helper.parseError(this, error)
                })

                // Lookup Spek Merk
                this.$axios.get(`barang-merk/spesifikasi?merkId=${newVal.id}`).then(response => {
                    this.optKendaraanSpekMerk = response.data
                })
                .catch(error => {
                    this.$helper.parseError(this, error)
                })
            }

        },

        'input.tipeKendaraan': function(newVal) {

            this.optKendaraanTahun = []
            this.input.tahunKendaraan = null

            this.optKendaraanKondisi = []
            this.input.kondisiKendaraan = null

            this.optPromo = []
            this.input.promo = []
            this.isPromoRetrieved = false

            if(newVal == null) { return }

            if(newVal != null){

                // Lookup Tahun
                this.$axios.get(`barang-tipe/tahun/${newVal.id}`).then(response => {
                    this.optKendaraanTahun = response.data
                })
                .catch(error => {
                    this.$helper.parseError(this, error)
                })

                // Lookup Kondisi
                this.$axios.get(`barang-tipe/kondisi/${newVal.id}`).then(response => {

                    let responseKondisi = response.data
                    for (let y=0; y< responseKondisi.length; y++){
                        let dataKondisi = {}
                        dataKondisi.value = responseKondisi[y].id
                        dataKondisi.text = responseKondisi[y].name.substring(4)
                        this.optKendaraanKondisi.push(dataKondisi)
                    }

                })
                .catch(error => {
                    this.$helper.parseError(this, error)
                })

            }

        },

        'input.tahunKendaraan': function(newVal) {

            this.optPromo = []
            this.input.promo = []
            this.isPromoRetrieved = false
                
        }

    },
    created(){
        this.init()
    }
}
</script>
